import { createSvgIcon } from '@mui/material';

export const ActiveCircleIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <circle id="BG" cx="10" cy="10" r="6" stroke="currentColor" strokeWidth="4" />
    </g>
  </svg>,
  'IconCircle',
);
